module.exports = __webpack_public_path__ + "theme/assets/img/dd7dbea6f7e683bb05d17fa7c24399b2.png";